import { createSelector } from 'reselect'

const drawItSelector = state => state.drawIt

const drawItCancelSelector = createSelector(
	[ drawItSelector],
	drawItState => ({
		isModified: drawItState.isModified,
	})
)

export default drawItCancelSelector
